import React, { ReactElement, ReactNode } from "react";
import Button from "@material-ui/core/Button";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box } from "@material-ui/core";
import useStyles from "./styles";


/**
 * We Omit 'title' from DialogProps because DialogProps (in some MUI versions)
 * declares a 'title' prop typed as string which conflicts with our ReactNode title.
 */
export interface CustomDialogProps extends Omit<DialogProps, "open" | "title" | "onClose"> {
  /** The element that triggers the dialog when clicked */
  trigger: ReactElement;
  /** Optional dialog title (can be ReactNode) */
  title?: ReactNode;
  /** Dialog content */
  children?: ReactNode;
  /**
   * Render prop that receives `handleClose` callback
   * so the caller can close the dialog from inside actions
   */
  actions?: (handleClose: () => void) => ReactNode;
  onClose?: () => void;
  isButtonDisabled?: boolean;
}

 const CustomDialog: React.FC<CustomDialogProps> = ({
  trigger,
  title,
  children,
  actions,
  isButtonDisabled,
  ...props
}) => {
  const [open, setOpen] = React.useState(false);
  const styles = useStyles();
  const {onClose} = props;
  const handleClick = () => {
    if (isButtonDisabled === null || !isButtonDisabled) {
      setOpen(!open);
    }
  };

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Box>
      <Box onClick={handleClick}>{trigger}</Box>
      <Dialog
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        {...props}
      >
        <DialogTitle id="alert-dialog-title" className={styles.dialogTitle}>
          {title}
        </DialogTitle>
        <DialogContent className={styles.dialogTextContainer}>
          <Box className={styles.dialogText}>{children}</Box>
        </DialogContent>
        <DialogActions className={styles.dialogActions}>
          {actions ? actions(handleClose) : (
            <Button color="primary" autoFocus onClick={handleClose} className="">
              Close
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default CustomDialog